/// <amd-module name="typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils" />

/// <reference path="../../../typings/typeahead/ExpediaSuggestServiceRequestGenerator.d.ts" />

import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

export function addFeatureFlag(
        featureFlag: string,
        configuration: IStripingConfiguration[],
        params: ISuggestServiceQueryParams,
        context: IContext,
        options?: any): ISuggestServiceQueryParams {
    if (typeof params !== "undefined") {
        params.features = params.features && params.features.length &&
        params.features.push ? params.features || [] : [];
        if (ExecutionHelper.shouldExecute(context, configuration) && params.features.indexOf(featureFlag) < 0) {
            params.features.push(featureFlag);
        }
    }
    return params;
}
